<div class="student-tab student-tab-assignments">
    <div class="student-tab__header">
        <span class="student-tab__text">Add an assignment:</span>
        <form
            name="beginAssignmentForm"
            (ngSubmit)="submitAssignmentsForm($event)"
            novalidate
        >
            <input
                [(ngModel)]="assignmentcode"
                name="assignmentcode"
                type="text"
                class="student-tab__input"
                id="enter-assignment-code"
                placeholder="Enter code e.g., banana1234"
                required
            />
            <input
                id="join-btn"
                type="submit"
                value="Go"
                class="student-tab__button btn"
            />
        </form>
        <p *ngIf="hasError">This field is required.</p>
    </div>
    <div class="student-tab__body">
        <ul id="assignmentsList" class="assignments no-list-style">
            <li *ngIf="populationComplete && assignments.length === 0">
                <p>You do not have any assignments.</p>
            </li>
            <li *ngIf="!populationComplete">
                <div class="ring-loader-container">
                    <div class="ring-loader"></div>
                </div>
            </li>
            <ng-container *ngIf="populationComplete">
                <li
                    *ngFor="let assignment of displayableAssignments"
                    class="assignment-tray-item"
                    [ngClass]="{ closed: !isActive(assignment.id) }"
                >
                    <span class="assignment-show-info">
                        <i
                            (click)="toggleActive(assignment.id)"
                            class="lm lm-dash-add"
                        ></i>
                        <i
                            (click)="toggleActive(assignment.id)"
                            class="lm lm-dash-delete"
                        ></i>
                    </span>
                    <div class="assignment-content">
                        <i
                            *ngIf="isPosterAssignment(assignment)"
                            class="lm lm-assignment-icon lm-page"
                        ></i>
                        <i
                            *ngIf="isPuzzleAssignment(assignment)"
                            class="lm lm-assignment-icon lm-jigsaw-puzzle"
                        ></i>
                        <i
                            *ngIf="isQuizAssignment(assignment)"
                            class="lm lm-assignment-icon lm-checked-box"
                        ></i>
                        <i
                            *ngIf="isLesson(assignment) && !isIlp(assignment)"
                            class="lm lm-assignment-icon lm-screen-text"
                        ></i>
                        <i
                            *ngIf="isIlp(assignment)"
                            class="lm lm-assignment-icon lm-ilp"
                        ></i>
                        <span class="title">{{
                            assignment.activity.name
                        }}</span>
                        <span class="assignment-status">
                            <img
                                *ngIf="assignment.completed"
                                src="{{ checkSignURL }}"
                                class="checkmark-img"
                            />
                            <a
                                *ngIf="
                                    !assignment.completed &&
                                    assignment.status === 'started'
                                "
                                href="{{ assignment.student_result_url }}"
                                target="_self"
                                >Resume <i class="lm lm-right-arrow"></i
                            ></a>
                            <a
                                class="student-tab__button"
                                *ngIf="
                                    !assignment.completed &&
                                    assignment.status === 'not_started'
                                "
                                (click)="startAssignment(assignment)"
                                >Start</a
                            >
                        </span>
                    </div>
                    <div
                        *ngIf="isActive(assignment.id)"
                        class="show-info clearfix"
                    >
                        <span class="info-item"
                            ><b>Code:</b> {{ assignment.activity.code }}</span
                        >
                        <span class="info-item"
                            ><b>Date:</b>
                            {{
                                assignment.date_created | date: "MMMM d, yyyy"
                            }}</span
                        >
                        <span class="info-item"
                            ><b>Teacher:</b>
                            {{ assignment.activity.teacher_name }}</span
                        >
                        <span
                            *ngIf="assignment.rosters !== null"
                            class="info-item"
                            ><b>Classes:</b> {{ assignment.rosters }}</span
                        >
                        <div class="info-desc">
                            <p>{{ assignment.activity.description }}</p>
                        </div>
                        <a
                            href="{{ assignment.student_result_url }}"
                            target="_self"
                            *ngIf="assignment.completed"
                            [ngClass]="{
                                'info-retake': isLesson(assignment),
                                'pull-right': !isLesson(assignment)
                            }"
                        >
                            <span *ngIf="isLesson(assignment)">Retake</span>
                            <span *ngIf="!isLesson(assignment)">Revise</span>
                            this assignment
                            <i class="lm lm-right-arrow"></i>
                        </a>
                    </div>
                </li>
            </ng-container>
        </ul>
        <div
            class="show-more-results std-mgb"
            [ngClass]="{ closed: !shouldPaginate() }"
        >
            <span class="btn btn-show-more" (click)="showMore()">
                Show More
            </span>
        </div>
    </div>
</div>
